<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '';
    export let type: string = 'text';
    export let placeholder: string = '';
    export let disabled: boolean = false;
    export let required: boolean = false;

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const URL_RE   = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
    const TEL_RE   = /^\+?[\d\s\-().]{7,20}$/;

    let touched = false;
    let inputEl: HTMLInputElement | null = null;

    errors[name] = [];

    const validate = (val: string = value) => {
        const errs: string[] = [];
        const trimmed = val.trim();
        // For number inputs the browser returns "" for bad input — use validity API
        const badNumber = type === 'number' && inputEl?.validity.badInput;
        if (badNumber) {
            errs.push('Enter a valid number');
        } else if (required && !trimmed) {
            errs.push('This field is required');
        } else if (trimmed) {
            if (type === 'email' && !EMAIL_RE.test(trimmed)) {
                errs.push('Enter a valid email address');
            } else if (type === 'url' && !URL_RE.test(trimmed)) {
                errs.push('Enter a valid URL (e.g. https://example.com)');
            } else if (type === 'tel' && !TEL_RE.test(trimmed)) {
                errs.push('Enter a valid phone number');
            }
        }
        errors[name] = errs;
    };
    validate();

    const handleInput = (e: Event) => {
        const el = e.currentTarget as HTMLInputElement;
        value = el.value;
        if (touched) validate(value);
    };

    const handleBlur = (e: FocusEvent) => {
        touched = true;
        validate((e.currentTarget as HTMLInputElement).value);
    };

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <input
        {type}
        {name}
        {placeholder}
        {disabled}
        {required}
        value={value}
        bind:this={inputEl}
        on:input={handleInput}
        on:blur={handleBlur}
        class:error={errors[name].length > 0}
        on:change
    />
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
